module.exports = __webpack_public_path__ + "img/symbol_6.66f5b892.png";